import * as Styles from './Skill.styles';

type SkillProps = {
  name: string;
};

const Skill = function ({ name }: SkillProps): JSX.Element {
  return <Styles.Container>{name}</Styles.Container>;
};

export default Skill;
